<script lang="ts" setup>
import { computed } from 'vue';
import BaseButton from '@/atoms/BaseButton.vue';
import BaseLabel from '@/atoms/BaseLabel.vue';

export type PageNavigationProps = {
  currentPage: number;
  totalPages: number;
};

const props = defineProps<PageNavigationProps>();

const emit = defineEmits<{
  prev: [];
  next: [];
}>();

const canGoPrev = computed(() => props.currentPage > 1);
const canGoNext = computed(() => props.currentPage < props.totalPages);
</script>

<template>
  <BaseButton
    type="primary"
    size="small"
    icon-name="chevron-left"
    :state="canGoPrev ? 'default' : 'disabled'"
    @click="emit('prev')"
  />
  <BaseLabel
    :text="`${currentPage} / ${totalPages}`"
    preset="small"
    color="secondary"
  />
  <BaseButton
    type="primary"
    size="small"
    icon-name="chevron-right"
    :state="canGoNext ? 'default' : 'disabled'"
    @click="emit('next')"
  />
</template>
